import { RootState } from "../../../../../redux/store";
import * as constants from "./constants";

export const isItemsLoading = (state:RootState) => state.customers.itemsLoading;
export const isItemActionLoading = (state:RootState) => state.customers.actionsLoading;
export const getItems = (state:RootState) => state.customers.items;
export const getItemsSelect = (state:RootState) => state.customers.dropDownItems;
export const getItemsCount = (state:RootState) => state.customers.itemsCount;
export const getItemForEdit = (state:RootState) => state.customers.itemForEdit;
export const getError = (state:RootState) => state.customers.error;
export const getErrorAction = (state:RootState) => state.customers.errorAction

export const getCustomersCreditData = (state:RootState) => state.customers[constants.CREDIT_DATA];
export const getCustomersCreditDataCount = (state:RootState) => state.customers[constants.CREDIT_DATA_ITEMS_COUNT];
export const getCustomersCreditDataLoading = (state:RootState) => state.customers[constants.CREDIT_DATA_LOADING];

export const getCustomersClassificationData = (state:RootState) => state.customers[constants.CLASSIFICATION];
export const getCustomersClassificationDataCount = (state:RootState) => state.customers[constants.CLASSIFICATION_ITEMS_COUNT];
export const getCustomersClassificationDataLoading = (state:RootState) => state.customers[constants.CLASSIFICATION_LOADING];
export const classificationFilters = (state:RootState) => state.customers[constants.CLASSIFICATION_FILTERS];

export const getCustomersBlockData = (state:RootState) => state.customers[constants.BLOCK_DATA];
export const getCustomersBlockDataCount = (state:RootState) => state.customers[constants.BLOCK_DATA_ITEMS_COUNT];
export const getCustomersBlockDataLoading = (state:RootState) => state.customers[constants.BLOCK_DATA_LOADING];

export const getWholesalers = (state:RootState) => state.customers[constants.WHOLESALERS];
export const getWholesalersCount = (state:RootState) => state.customers[constants.WHOLESALERS_ITEMS_COUNT];
export const getWholesalersLoading = (state:RootState) => state.customers[constants.WHOLESALERS_LOADING];

export const getAdvancedFilterData = (state:RootState) => state.customers[constants.ADVANCED_FILTER];
export const getAdvancedFilterCount = (state:RootState) => state.customers[constants.ADVANCED_FILTER_ITEMS_COUNT];
export const getAdvancedFilterLoading = (state:RootState) => state.customers[constants.ADVANCED_FILTER_LOADING];

export const getShipToAddressRegionId = (state:RootState) => state.customers.itemForEdit.shipToAddress?.regionId;

export const getShipToAddressCountryId = (state:RootState) => state.customers.itemForEdit.shipToAddress?.countryId;

export const getBillToAddressRegionId = (state:RootState) => state.customers.itemForEdit.billToAddress?.regionId;

export const getBillToAddressCountryId = (state:RootState) => state.customers.itemForEdit.billToAddress?.countryId;

export const getValidationErrors = (state:RootState) => state.customers.validationErrors;




/**
 * !!!!!!!!!!!!!!!!!!!!!!!!!!
 */
 export const itemForEditId = (state:RootState) => state.customers.itemForEdit?.id;

 export const tableItemsForEdit = (state:RootState) => state.customers.itemForEdit?.equipmentTab?.customerEquipments || [];
 export const totalTableItemsCount = (state:RootState) => state.customers.itemForEdit?.equipmentTab?.totalCount || 0;
 
 export const tableItemsLoading = (state:RootState) => state.customers.equipmentLoading;
 
 export const addedTableItems = (state:RootState) => state.customers.itemForEdit?.createCustomerEquipments || [];
 export const removedTableItems = (state:RootState) => state.customers.itemForEdit?.deleteCustomerEquipments || [];

 export const searchTablesItems = (state:RootState) => state.customers.searchedEquipment;
 /**
  * !!!!!!!!!!!!!!!!!!!!!!!!!!
  */
 
 export const searchedCustomers = (state:RootState) => state.customers.searchedCustomers;
 export const isClientSearchLoading = (state:RootState) => state.customers.searchedCustomersLoading;
